import {Component} from 'react'
import TabItem from '../TabItem'
import ThumbnailItem from '../ThumbnailItem'
import ScoreCard from '../ScoreCard'
import './index.css'

class MatchGame extends Component {
  constructor(props) {
    super(props)
    const {imagesList} = this.props
    this.state = {
      score: 0,
      timeElapsed: 60,
      activeTabId: 'FRUIT',
      targetImage: imagesList[0],
      isGameOver: false,
    }
  }

  componentDidMount() {
    this.startTimer()
  }

  componentWillUnmount() {
    this.clearTimer()
  }

  startTimer = () => {
    this.timerId = setInterval(this.tick, 1000)
  }

  clearTimer = () => {
    clearInterval(this.timerId)
  }

  tick = () => {
    const {timeElapsed} = this.state
    if (timeElapsed === 1) {
      this.clearTimer()
      this.setState({timeElapsed: 0, isGameOver: true})
    } else {
      this.setState(prevState => ({timeElapsed: prevState.timeElapsed - 1}))
    }
  }

  onChangeTab = tabId => {
    this.setState({activeTabId: tabId})
  }

  onResetGame = () => {
    const {imagesList} = this.props
    this.setState(
      {
        score: 0,
        timeElapsed: 60,
        activeTabId: 'FRUIT',
        targetImage: imagesList[0],
        isGameOver: false,
      },
      this.startTimer,
    )
  }

  onClickThumbnail = id => {
    const {targetImage} = this.state
    const {imagesList} = this.props

    if (id === targetImage.id) {
      const randomIndex = Math.floor(Math.random() * imagesList.length)
      this.setState(prevState => ({
        score: prevState.score + 1,
        targetImage: imagesList[randomIndex],
      }))
    } else {
      this.clearTimer()
      this.setState({isGameOver: true})
    }
  }

  renderGameView = () => {
    const {activeTabId, targetImage} = this.state
    const {tabsList, imagesList} = this.props
    const filteredImages = imagesList.filter(
      eachImage => eachImage.category === activeTabId,
    )

    return (
      <div className="game-main-content">
        <img src={targetImage.imageUrl} alt="match" className="match-image" />
        <ul className="tabs-list">
          {tabsList.map(eachTab => (
            <TabItem
              key={eachTab.tabId}
              tabDetails={eachTab}
              isActive={eachTab.tabId === activeTabId}
              onChangeTab={this.onChangeTab}
            />
          ))}
        </ul>
        <ul className="thumbnails-list">
          {filteredImages.map(eachImage => (
            <ThumbnailItem
              key={eachImage.id}
              imageDetails={eachImage}
              onClickThumbnail={this.onClickThumbnail}
            />
          ))}
        </ul>
      </div>
    )
  }

  render() {
    const {score, timeElapsed, isGameOver} = this.state

    return (
      <div className="app-container">
        <nav className="navbar-container">
          <div className="navbar-content">
            <img
              src="https://assets.ccbp.in/frontend/react-js/match-game-website-logo.png"
              alt="website logo"
              className="website-logo"
            />
            <div className="score-timer-container">
              <p className="nav-score">
                Score: <span className="score-highlight">{score}</span>
              </p>
              <div className="timer-wrapper">
                <img
                  src="https://assets.ccbp.in/frontend/react-js/match-game-timer-img.png"
                  alt="timer"
                  className="timer-icon"
                />
                <p className="timer-text">{timeElapsed} sec</p>
              </div>
            </div>
          </div>
        </nav>
        <div className="game-body">
          {isGameOver ? (
            <ScoreCard score={score} onResetGame={this.onResetGame} />
          ) : (
            this.renderGameView()
          )}
        </div>
      </div>
    )
  }
}

export default MatchGame
